import React from 'react';
import _ from 'lodash';
import ReactApexChart from 'react-apexcharts';
import { useQuery } from 'react-fetching-library';
import { Stack, Card, CardContent, CardHeader, IconButton, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { SmallFormDateField } from '../../../components/small-fields/SmallFormDateField';
import { getSurveysStatisticsAction } from '../../../services/request';
import { BaseOptionChart } from '../../../components/chart';
import { formatDate } from '../../../services/functions';

export default function SurveyStatistics({ id }) {
  const [dateFrom, setDateFrom] = React.useState(null);
  const [dateTo, setDateTo] = React.useState(null);
  const { payload, loading, error } = useQuery(getSurveysStatisticsAction(id, dateFrom, dateTo));
  const [statistics, setStatistics] = React.useState({ 'charts': [], 'answers': [] });

  React.useEffect(() => {
    if (!loading && !error) {
      setStatistics(payload);
      console.log(payload);
    }
  }, [loading]);

  const handleChangeDateFrom = value => {
    setDateFrom(formatDate(value));
  };

  const handleChangeDateTo = value => {
    setDateTo(formatDate(value));
  };


  return (
    <Stack spacing={2} mt={2}>
      <Typography variant="h4">{payload?.title ?? ''}</Typography>
      <Stack direction="row" spacing={4}>
        <Stack direction="row" spacing={1}>
          <SmallFormDateField sx={{ width: '180px' }} views={['month', 'year']} value={dateFrom} onChange={handleChangeDateFrom} inputFormat={'MMMM yyyy'} label="Od"/>
          <IconButton onClick={() => setDateFrom(null)}><ClearIcon /></IconButton>
        </Stack>
        <Stack direction="row" spacing={1}>
          <SmallFormDateField sx={{ width: '180px' }} views={['month', 'year']} value={dateTo} onChange={handleChangeDateTo} inputFormat={'MMMM yyyy'} label="Do"/>
          <IconButton onClick={() => setDateTo(null)}><ClearIcon /></IconButton>
        </Stack>
      </Stack>
      {statistics.charts.map((item, index) => (
        <Card key={index}>
          <CardHeader title={item.title}/>
          <CardContent >
            <ReactApexChart
              options={_.merge(BaseOptionChart(), {
                chart: { id: `chart-${index}` },
                xaxis: {
                  categories: item.labels
                },
                dataLabels: {
                  enabled: true,
                  formatter (val) {
                    return `${val}`;
                  },
                  style: {
                    fontSize: '20px',
                    colors: ['#fff']
                  }
                },

                tooltip: {
                  x: {
                    show: true
                  }
                }
              })}
              series={[{ name: ' ', data: item.values }]}
              height={364}
              type="bar"
            />
          </CardContent>
        </Card>
      ))}
      {statistics.answers.map((item, index) => (
        <Card key={index}>
          <CardHeader title={item.title}/>
          <CardContent sx={{ 'maxHeight': '600px', overflow: 'auto' }}>
            {item.data.map((answer, i) => <Typography key={i}>- {answer}</Typography>)}
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};
